<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->
    <app-nav></app-nav>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
  import Nav from './components/Nav.vue';
  import Footer from './components/Footer.vue';

  export default {
    components: {
      appNav: Nav,
      appFooter: Footer
    }
  };
</script>
<style>
  .brand-logo,
  .navbar-nav a {
    font-weight: 500;
    color: #333;
  }
  .calendar,
  .copyright,
  .item-lead,
  .welcome,
  .welcome-text {
    text-align: center;
  }
  body {
    margin-top: 60px;
    background: #fafafa;
    font-family: 'Open Sans', sans-serif;
    overflow-x: hidden;
  }
  .container-bg {
    background: #fff;
    border-left: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2;
  }
  .navbar {
    padding: 5px 0;
    border-bottom: 1px solid #f2f2f2;
    background: #fff;
    font-family: Roboto, sans-serif;
  }
  .navbar-nav > li.select a,
  .navbar-nav > li > a,
  .navbar-nav > li > a:before {
    background-color: transparent !important;
  }
  .navbar-nav {
    font-size: 13px;
  }
  .navbar-nav a {
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .navbar-nav > li > a {
    margin: 0 15px;
    padding: 15px 0;
  }
  .navbar-nav > li > a:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    border-bottom: 2px solid #009688;
    visibility: hidden;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
  }
  .navbar-nav > li.select > a:before {
    border-bottom: none;
  }
  .navbar-nav > li > a:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
  .navbar-nav > li.select a {
    padding-bottom: 13px;
  }
  .brand-logo {
    font-size: 30px;
    /* margin-left: 0 !important;
                                                        padding: 13px 0; */
  }
  .contact-submit,
  .welcome {
    font-weight: 600;
    text-transform: uppercase;
  }
  .brand-logo:hover {
    color: #333;
  }
  .icon-bar {
    color: #333 !important;
    background: #333;
  }
  .main-image {
    width: 100%;
    height: 300px;
    opacity: 1;
    visibility: inherit;
    z-index: 20;
    background-image: url('./assets/images/15119541611_b8d171d1f4_k.jpg');
    background-color: rgba(0, 0, 0, 0);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border: 1px solid #f2f2f2;
  }
  .welcome {
    margin: 40px auto 10px;
    font-size: 40px;
  }
  .welcome-line {
    margin: 0 auto 40px;
    border-bottom: 2px solid #009688;
    width: 40px;
  }
  .welcome-text {
    padding: 0 40px;
    font-size: 16px;
    line-height: 26px;
  }

  .item-head,
  .item-sub-text {
    font-weight: 600;
    text-transform: uppercase;
  }
  input:active,
  input:focus,
  textarea:active,
  textarea:focus {
    outline: 0 !important;
  }
  .datepicker {
    cursor: text;
  }
  .item-head {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
    color: #333;
  }
  .item-sub {
    display: block;
    margin: 20px auto 10px;
    padding: 0;
    position: relative;
  }
  .item-sub.mission-line {
    padding: 0;
  }
  .item-sub-line {
    margin: 0 auto;
    border-top: 1px solid #eee;
    width: 100%;
  }
  .item-sub-text {
    margin: 0 auto;
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: relative;
    top: -12px;
    font-size: 10px;
    padding: 0 15px;
    letter-spacing: 2px;
    color: #bbb;
    background-color: #fff;
  }
  .item-lead {
    margin: 60px 0 40px;
  }
  .enterprise-lead-head {
    font-size: 20px;
    line-height: 28px;
    text-transform: uppercase;
    letter-spacing: 0;
    color: #333;
    font-weight: 700;
  }
  .more-solutions-icon {
    font-size: 20px !important;
    color: #009688;
  }
  .welcome-pics {
    margin: 0 auto;
  }
  .cabin-image {
    margin: 40px auto;
    border: 1px solid #ddd;
    width: auto;
  }
  .footer {
    margin: 0 -15px;
    padding: 40px 0;
    background: #333;
  }
  .copyright {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #999;
  }
  .contact-alert {
    margin: 25px 0 0;
    padding: 13px 20px;
    border: 0;
    color: #fff;
    font-size: 13px;
  }
  .alert-error {
    background: #f0614d;
  }
  .alert-submit {
    background: #2ec760;
  }

  .form-control {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 10px 12px;
    height: auto;
    text-decoration: none;
    color: #454545;
    border: 2px solid #ddd;
    border-radius: 0px;
  }
  .form-control[readonly] {
    background-color: #fff;
  }

  .btn {
    position: relative;
    margin: 10px 0px;
    padding: 12px 25px;
    font-size: 15px;
    font-weight: 600;
    height: 46px;
    border-radius: 3px;
    line-height: 20px !important;
    vertical-align: middle;
    transition: all 0.3s ease;
    border: none;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .btn-teal,
  .btn-teal:focus {
    color: #fff;
    background-color: #04a192;
    border: 1px solid #009688;
  }

  .btn-teal:active,
  .btn-teal.active,
  .btn-teal:hover {
    color: #fff;
    background-color: #009688;
    border: 1px solid #018376;
    outline: 0;
  }

  .calendar {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 200px;
    height: 0;
    overflow: hidden;
  }

  .calendar iframe,
  .calendar object,
  .calendar embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }

  @media only screen and (max-width: 767px) {
    .brand-logo {
      padding-left: 15px;
    }
    .welcome {
      font-size: 30px;
      word-wrap: break-word;
    }
    .form-control {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 450px) {
    .brand-logo {
      font-size: 20px;
    }
    .welcome {
      font-size: 24px;
      word-wrap: break-word;
    }
    .welcome-text {
      font-size: 14px;
    }
  }
</style>
